import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  policy: [],
  policyStatus: IDLE,

  connectedRisks: [],
  connectedRisksStatus: IDLE,

  createPolicyStatus: IDLE,
  updatePolicyStatus: IDLE,
  deletePolicyStatus: IDLE
};

const policySlice = createSlice({
  name: 'policy',
  initialState,
  reducers: {
    getPolicy(state) {
      state.policyStatus = LOADING;
    },
    getPolicySucceeded(state, action) {
      state.policy = action.payload;
      state.policyStatus = SUCCEEDED;
    },
    getPolicyFailed(state) {
      state.policyStatus = FAILED;
    },

    clearPolicy(state) {
      state.policy = [];
      state.policyStatus = IDLE;
    },

    getConnectedRisks(state) {
      state.connectedRisksStatus = LOADING;
    },
    getConnectedRisksSucceeded(state, action) {
      state.connectedRisks = action.payload;
      state.connectedRisksStatus = SUCCEEDED;
    },
    getConnectedRisksFailed(state) {
      state.connectedRisksStatus = FAILED;
    },

    createPolicy(state) {
      state.createPolicyStatus = LOADING;
    },
    createPolicySucceeded(state) {
      state.createPolicyStatus = SUCCEEDED;
    },
    createPolicyFailed(state) {
      state.createPolicyStatus = FAILED;
    },

    updatePolicy(state) {
      state.updatePolicyStatus = LOADING;
    },
    updatePolicySucceeded(state, action) {
      state.updatePolicyStatus = SUCCEEDED;
      state.policy = action.payload;
    },
    updatePolicyFailed(state) {
      state.updatePolicyStatus = FAILED;
    },

    deletePolicy(state) {
      state.deletePolicyStatus = LOADING;
    },
    deletePolicySucceeded(state) {
      state.deletePolicyStatus = SUCCEEDED;
    },
    deletePolicyFailed(state) {
      state.deletePolicyStatus = FAILED;
    }
  }
});

export const {
  getPolicy,
  getPolicySucceeded,
  getPolicyFailed,
  clearPolicy,
  getConnectedRisks,
  getConnectedRisksSucceeded,
  getConnectedRisksFailed,
  createPolicy,
  createPolicySucceeded,
  createPolicyFailed,
  updatePolicy,
  updatePolicySucceeded,
  updatePolicyFailed,
  deletePolicy,
  deletePolicySucceeded,
  deletePolicyFailed
} = policySlice.actions;

export default policySlice.reducer;
